import type { RouteRecordRaw } from "vue-router";

const router: RouteRecordRaw[] = [
  {
    path: "/file/explorer/:selectedFolderId?",
    name: "FileExplorer",
    component: () => import("./view/FMFileExplorer.vue"),
    props: (route) => ({
      selectedFolderId: !route.params.selectedFolderId ? -1 : Number(route.params.selectedFolderId),
    }),
  },
];

export default router;
